import {
  CreateReportBundleRequest,
  PublishReportBundleRequest,
  ReportBundleListResponse,
  ReportBundlePreviewContextResponse,
  ReportBundleResponse,
  ReportBundleRuntimeResponse,
  ReportBundleVersionResponse,
  ReportSdkTypesResponse,
  SaveReportBundleDraftRequest,
  UpdateReportBundleRequest,
} from '@/types/reportBundleTypes';
import { FusaReply } from '@/types/replyTypes';
import { AssistantMessage, AssistantStatusResponse, AssistantStreamEvent } from '@/types/reportAssistantTypes';
import { Client } from './client';

export class ReportBundleFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  list(): Promise<ReportBundleListResponse> {
    return this.client.read('/api/report-bundles');
  }

  create(data: CreateReportBundleRequest): Promise<ReportBundleResponse> {
    return this.client.create('/api/report-bundles', data);
  }

  read(id: string): Promise<ReportBundleResponse> {
    return this.client.read(`/api/report-bundles/${id}`);
  }

  update(id: string, data: UpdateReportBundleRequest): Promise<ReportBundleResponse> {
    return this.client.patch(`/api/report-bundles/${id}`, data);
  }

  saveDraft(id: string, data: SaveReportBundleDraftRequest): Promise<ReportBundleResponse> {
    return this.client.update(`/api/report-bundles/${id}/draft`, data);
  }

  publish(id: string, data: PublishReportBundleRequest = {}): Promise<ReportBundleVersionResponse> {
    return this.client.create(`/api/report-bundles/${id}/versions`, data);
  }

  readVersion(id: string, versionId: string): Promise<ReportBundleVersionResponse> {
    return this.client.read(`/api/report-bundles/${id}/versions/${versionId}`);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/report-bundles/${id}`);
  }

  sdkTypes(): Promise<ReportSdkTypesResponse> {
    return this.client.read('/api/report-bundles/sdk-types');
  }

  runtime(versionId: string): Promise<ReportBundleRuntimeResponse> {
    return this.client.read(`/api/report-bundles/runtime/${versionId}`);
  }

  /** a run as the saved draft reads it, for the preview */
  previewContext(id: string, runId: string): Promise<ReportBundlePreviewContextResponse> {
    return this.client.create(`/api/report-bundles/${id}/preview-context`, { runId });
  }

  assistantStatus(): Promise<AssistantStatusResponse> {
    return this.client.read('/api/report-bundles/assistant');
  }

  /** one reply of the assistant, its events handed over as they stream; an error response comes back instead */
  assistantReply(id: string, messages: AssistantMessage[], onEvent: (event: AssistantStreamEvent) => void, signal?: AbortSignal): Promise<FusaReply | null> {
    return this.client.postEventStream(`/api/report-bundles/${id}/assistant`, { messages }, (data) => onEvent(JSON.parse(data) as AssistantStreamEvent), signal);
  }
}
